import { MOBILE_OVERLAY_ROUTES, MobileOverlayRouteType } from "./constants";

// At md+, Profile uses the account menu, Planner uses the primary sidebar, and
// Manage Pages uses a modal. Their overlay selection does not transfer to those
// surfaces, so clear it.
const OVERLAY_ROUTES_CLEARED_AT_MD: MobileOverlayRouteType[] = [
  "profile",
  "planner",
  "manage_pages",
];

export const shouldUseMobileRoutingOverlay = (
  selectedOverlayRoute: string | null,
  isLgOrLarger: boolean,
): selectedOverlayRoute is MobileOverlayRouteType =>
  !isLgOrLarger &&
  selectedOverlayRoute !== null &&
  MOBILE_OVERLAY_ROUTES.includes(selectedOverlayRoute as MobileOverlayRouteType);

export const shouldCloseMobileOnlyOverlay = (
  selectedOverlayRoute: string | null,
  isMdOrLarger: boolean,
) =>
  isMdOrLarger &&
  selectedOverlayRoute !== null &&
  OVERLAY_ROUTES_CLEARED_AT_MD.includes(selectedOverlayRoute as MobileOverlayRouteType);
